import { Component, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from './services/storage.service';
import { CloudService } from './services/cloud.service';
import { CloudModel } from './models/cloud-model';
import { storage as storageCatalog, event as eventCatalog } from './utils/catalog';
import { Subscription } from 'rxjs';
import { EventService } from './services/event.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'MH Portal';
  public cloud: CloudModel = null;

  private authSubscription: Subscription = null;
  private cloudSubscription: Subscription = null;

  constructor(private storageService: StorageService, private eventService: EventService, private cloudService: CloudService, private authService: AuthService) {}

  private async loadCloud() {
    this.cloud = (await this.authService.isLoggedIn()) ? await this.cloudService.getCloud() : null;
  }

  private async init() {
    this.loadCloud();
    this.authSubscription = this.storageService.subscribe(() => {
      this.loadCloud();
    }, [storageCatalog.keys.auth]);
    this.cloudSubscription = this.eventService.subscribe(eventCatalog.types.cloudUpdate, () => {
      this.loadCloud();
    });
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
      this.authSubscription = null;
    }
    if (this.cloudSubscription) {
      this.cloudSubscription.unsubscribe();
      this.cloudSubscription = null;
    }
  }
}
